/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The PartnerControllerDtoPartnerAccountCheckRequest model module.
 * @module model/PartnerControllerDtoPartnerAccountCheckRequest
 * @version 1.0
 */
class PartnerControllerDtoPartnerAccountCheckRequest {
    /**
     * Constructs a new <code>PartnerControllerDtoPartnerAccountCheckRequest</code>.
     * @alias module:model/PartnerControllerDtoPartnerAccountCheckRequest
     * @param email {String} 
     */
    constructor(email) { 
        
        PartnerControllerDtoPartnerAccountCheckRequest.initialize(this, email);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, email) { 
        obj['email'] = email;
    }

    /**
     * Constructs a <code>PartnerControllerDtoPartnerAccountCheckRequest</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/PartnerControllerDtoPartnerAccountCheckRequest} obj Optional instance to populate.
     * @return {module:model/PartnerControllerDtoPartnerAccountCheckRequest} The populated <code>PartnerControllerDtoPartnerAccountCheckRequest</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new PartnerControllerDtoPartnerAccountCheckRequest();

            if (data.hasOwnProperty('email')) {
                obj['email'] = ApiClient.convertToType(data['email'], 'String');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>PartnerControllerDtoPartnerAccountCheckRequest</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>PartnerControllerDtoPartnerAccountCheckRequest</code>.
     */
    static validateJSON(data) {
        // check to make sure all required properties are present in the JSON string
        for (const property of PartnerControllerDtoPartnerAccountCheckRequest.RequiredProperties) {
            if (!data[property]) {
                throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
            }
        }
        // ensure the json data is a string
        if (data['email'] && !(typeof data['email'] === 'string' || data['email'] instanceof String)) {
            throw new Error("Expected the field `email` to be a primitive type in the JSON string but got " + data['email']);
        }

        return true;
    }


}

PartnerControllerDtoPartnerAccountCheckRequest.RequiredProperties = ["email"];

/**
 * @member {String} email
 */
PartnerControllerDtoPartnerAccountCheckRequest.prototype['email'] = undefined;






export default PartnerControllerDtoPartnerAccountCheckRequest;

